import con from "../../../connection";

const path = '/idms';

const idms = (url: string) => (version: string) => ({
  get: () => con.getFile<Blob>(url + path + "/" + version, {})
})

export default idms;